import SectionMessage from '@atlaskit/section-message/section-message';
import type { JSX } from 'react';
import { useIntl } from 'react-intl';

import { registeredContent } from '../content';

export type TestMessageProps = {
	onDismiss: () => void;
};

export const TestMessage = ({ onDismiss }: TestMessageProps): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<SectionMessage
			title={formatMessage(registeredContent.default.title)}
			appearance="information"
			isDismissible
			onDismiss={onDismiss}
		>
			<p>{formatMessage(registeredContent.default.description)}</p>
		</SectionMessage>
	);
};
